import { WebStorageStateStore, Log, User } from 'oidc-client';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConstService } from '../core/services/user-services/const.service';
import { Md5 } from 'ts-md5';

export class RedisStorage implements WebStorageStateStore {

  private prefix = 'oidc.';
  private user: User;
  private httpClient: HttpClient;
  private constService: ConstService;
  private authId: string;
  private localKey = `${this.prefix}user:authId`;

  constructor(httpClient: HttpClient, constService: ConstService) {
    this.httpClient = httpClient;
    this.constService = constService;
    this.authId = this._makeString();
  }

  async set(key: string, value: any): Promise<void> {
    const authId = localStorage.getItem(this.localKey);
    if(authId === null) {
      localStorage.setItem(this.localKey, this.authId);
      key = this.prefix + key + `:${this.authId}`;
      this.user = JSON.parse(value);
      await this.httpClient.post(this.constService.getRedisUri(), { key, value }).toPromise();
    }
    return Promise.resolve();
  }

  async get(key: string): Promise<any> {
    const authId = localStorage.getItem(this.localKey);
    if(authId !== null) {
      key = this.prefix + key + `:${authId}`;
      const params = new HttpParams().set('key', key);
      const value = await this.httpClient.get(this.constService.getRedisUri() + '/Get', {params, responseType: 'text'}).toPromise();
      return Promise.resolve(value);
    }
    return Promise.resolve();
  }

  async remove(key: string): Promise<any> {
    const authId = localStorage.getItem(this.localKey);
    if(authId !== null) {
      localStorage.removeItem(this.localKey);
      key = this.prefix + key + `:${authId}`;
      const params = new HttpParams().set('key', key);
      const value = await this.httpClient.delete(this.constService.getRedisUri() + '/Delete', {params, responseType: 'text'}).toPromise();
      return Promise.resolve(value);
    }
    return Promise.resolve();
  }

  getAllKeys(): Promise<string[]> {
    throw new Error("Method not implemented.");
  }

  private _makeString(): string {
    let outString: string = '';
    let inOptions: string = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    for (let i = 0; i < 10; i++) {
      outString += inOptions.charAt(Math.floor(Math.random() * inOptions.length));
    }
    outString = new Md5().appendStr(outString).end().toString();
    return outString;
  }
}
